export default __webpack_public_path__ + "static/media/ic_alert_error.ad22d956.svg";